import React from 'react';
import { Avatar } from "@/components"
import { Icon } from "antd"
import "./style.less";

function Comment({ className = "", data = [{ name: "", head: "", addTime: "", content: "" }], onRemove = () => { }, theme = "hight" }) {

    return (
        <div className={`child-top-sm ${className}`}>
            {data.map(({ key, name, head, addTime, content, remove = false }) => (
                <div key={key} className={`com-comment--${theme} flex child-left-sm`}>
                    <Avatar width="25px" url={head} />
                    <div>
                        <div className="flex ver child-left-sm">
                            <span className="dark-second">{name}</span>
                            <span className="font-size-14 dark-disable">{addTime}</span>
                            {remove && <Icon onClick={onRemove.later(key)} type="delete" />}
                        </div>
                        <pre className="com-comment__content">{content}</pre>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Comment;